import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { SpsSideNavComponent } from "../components/index";
import { SpsSideNavBranchComponent } from "../components/side-nav-branch/sps-side-nav-branch.component";
import { SpsDSCoreModule } from "./sps-ds-core.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        SpsDSCoreModule
    ],
    declarations: [
        SpsSideNavComponent,
        SpsSideNavBranchComponent
    ],
    exports: [
        SpsSideNavComponent,
        SpsSideNavBranchComponent
    ]
})
export class SpsSideNavModule {}
